import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { PhoneIcon, SideArrow } from "../common/icons/svg";
import equal from "fast-deep-equal";
import { getDateFormatted4 } from "../../common/common";
import moment from "moment";
import { renderImg } from "../common/icons/img";

class header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headertext1: [],
      headertext2: [],
    };
    this.updatedata = this.updatedata.bind(this);
  }

  componentDidMount() {
    this.updatedata();
  }

  componentDidUpdate(prevProps) {
    if (!equal(this.props.search.header, prevProps.search.header)) {
      this.updatedata();
    }
  }

  updatedata() {
    if (Object.keys(this.props.search.header).length > 0) {
      this.setState({
        headertext1: this.props.search.header.text1,
        headertext2: this.props.search.header.text2,
      });
    }
  }

  render() {
    let headertext1 = [];
    let headertext2 = [];
    const prop = this.props.search;
    const order = prop.order;
    const Bookingnumber = window.Bookingcontact ? window.Bookingcontact : false;
    const othernumber = window.otherContact ? window.otherContact : false;
    let trip = prop.searchParams.mode;
    const urlParams = new URLSearchParams(window.location.search);
    const inSrp = window.location.pathname && window.location.pathname.indexOf("/search");
    const linkfromstoptocity = urlParams.get("linkfromstoptocity");
    if (prop.searchParams.mode === "roundtrip") {
      trip = "Return trip";
      if (!prop.searchParams.token) {
        trip = "Onward trip";
      }
    } else {
      trip = "Onward trip";
    }
    let fromcity = "",
      tocity = "";
    if (prop) {
      fromcity = prop.searchParams.fromCity
        ? prop.searchParams.fromCity.split("|")[1]
        : "";
      tocity = prop.searchParams.toCity
        ? prop.searchParams.toCity.split("|")[1]
        : "";
    }
    if (Object.keys(order).length > 0) {
      if (trip === "Onward trip") {
        fromcity = order.onward.fromCity;
        tocity = order.onward.toCity;
      }
      if (trip === "Return trip") {
        if (order.return && order.return.seats) {
          fromcity = order.return.fromCity;
          tocity = order.return.toCity;
        }
      }
    }
    if (this.state.headertext1.length > 0) {
      headertext1 = this.state.headertext1;
    } else {
      headertext1 = fromcity + " - " + tocity;
    }
    if (this.state.headertext2.length > 0) {
      headertext2 = this.state.headertext2;
    } else {
      headertext1 = trip;
    }

    const onwardData = order && order.onward;
    const returnData = order && order.return;
    return (
      <div className="headersection">
        <div className="headersection-inner flexed-justify" style={inSrp === 0 ? { padding: '0 3%' } : {}}>
          <div className="header-left flex-all-c">
            <span className="oplogo">
              <a href="/">
                <img src={window.awsImagePath + window.Searchlogo} alt="" />
              </a>
            </span>
            {/* <span className="triptype flexed-justify flex-coloumn">
              <div className="tripname">{headertext1}</div>
              <div className="othertext">{headertext2}</div>
            </span> */}
          </div>
          {
            linkfromstoptocity && onwardData && returnData &&
            <div className="link-city-wrap">
              <div className="city--wrap">
                <div>{onwardData && onwardData.fromCity}</div>
                <div>{onwardData && moment(onwardData.journeyDate + ' ' + onwardData.boardingTime).format("HH:mm")}{", "}{onwardData && getDateFormatted4(onwardData.journeyDate)}</div>
              </div>
              <div className="side--arrow">{renderImg('SideArrow')}</div>
              <div className="link-city-wrap">
                <div className="city--wrap">
                  <div>{onwardData && onwardData.toCity}</div>
                  <div>{onwardData && moment(onwardData.arrivalDate + ' ' + onwardData.arrivalTime).format("HH:mm")}{", "}{onwardData && getDateFormatted4(onwardData.arrivalDate)}</div>
                </div>
                <div className="side--arrow">{renderImg('SideArrow')}</div>
              </div>
              <div className="link-city-wrap">
                <div className="city--wrap">
                  <div>{returnData && returnData.toCity}</div>
                  <div>{returnData && moment(returnData.arrivalDate + ' ' + returnData.arrivalTime).format("HH:mm")}{", "}{returnData && getDateFormatted4(returnData.arrivalDate)}</div>
                </div>
              </div>
            </div>
          }
          <div className="header-right">
            {Bookingnumber ? (
              <React.Fragment>
                <span className="phoneicon">
                  {/* <PhoneIcon /> */}
                  {renderImg('PhoneIcon')}
                </span>
                <span className="querylink1 flexed-justify flex-coloumn">
                  <div>Booking Queries</div>
                  <div>{Bookingnumber}</div>
                </span>
              </React.Fragment>
            ) : (
              ""
            )}
            {othernumber ? (
              <span className="querylink2 flexed-justify flex-coloumn">
                {/* <div>Other Queries</div> */}
                {/* <div>{othernumber}</div> */}
                <div>Route Related Enquiry</div>
                <div>{"0471-2463799, 9447071021"}</div>
              </span>
            ) : (
              ""
            )}

            {window.customerProfile && window.customerProfile.MobileNumber ? (
              <span className="loginbutton">
                <a href="/welcome/logout">Logout</a>
              </span>
            ) : (
              <span className="loginbutton Login_Signup">
                <a>Login or Signup</a>
              </span>
            )}
            <span style={
              {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '34px',
                borderRadius: '30px',
                border: '1.5px solid #e72a01',
                color: '#e72a01',
                fontSize: '14px',
                margin: '0 0 0 15px',
                cursor: 'pointer',
                padding: '0 23px',
                fontWeight: '600'
              }
            }>
              <a href="/">Home</a>
            </span>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = function (store) {
  return store;
};
export default connect(mapStateToProps)(withRouter(header));
